import { Link } from 'react-router-dom';
import { useState, FormEvent } from 'react';

const footerLinks = [
  { name: '热门连载', path: '/category/hot' },
  { name: '完结经典', path: '/category/completed' },
  { name: '恋爱甜宠', path: '/category/romance' },
  { name: '奇幻冒险', path: '/category/fantasy' },
  { name: '都市职场', path: '/category/urban' },
];

const socialLinks = [
  { name: '微博', icon: 'ri-links-line', url: '#' },
  { name: '微信公众号', icon: 'ri-wechat-line', url: '#' },
  { name: '小红书', icon: 'ri-bookmark-line', url: '#' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-2xl mt-10 md:mt-14 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 select-none pointer-events-none">
        <p className="text-[10vw] font-bold text-foreground-800/15 leading-none whitespace-nowrap text-center">
          韩漫星球
        </p>
      </div>

      <div className="relative z-10 px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-book-open-line text-2xl text-primary-400"></i>
              <span className="text-xl font-bold font-heading">
                韩漫<span className="text-primary-400">星球</span>
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              最全的韩国漫画在线阅读平台，每日更新热门韩漫，提供极致的下拉式阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">分类导航</h4>
            <div className="space-y-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="block text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">关注我们</h4>
            <div className="space-y-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="flex items-center gap-2 text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-base`}></i>
                  <span>{social.name}</span>
                </a>
              ))}
              <Link
                to="/about"
                className="flex items-center gap-2 text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
              >
                <i className="ri-information-line text-base"></i>
                <span>关于我们</span>
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">订阅更新</h4>
            <p className="text-sm text-foreground-300 mb-3 leading-relaxed">
              订阅我们的邮件通知，第一时间获取最新漫画更新信息。
            </p>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱"
                className="flex-1 px-4 py-2 text-sm bg-foreground-900 border border-foreground-700 rounded-full focus:outline-none focus:border-primary-400 text-background-50 placeholder-foreground-500"
                required
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center bg-primary-500 hover:bg-primary-600 rounded-full cursor-pointer transition-colors flex-shrink-0"
              >
                <i className="ri-arrow-right-line text-background-50 text-base"></i>
              </button>
            </form>
            {subscribed && (
              <p className="text-xs text-accent-400 mt-2">订阅成功！感谢您的关注。</p>
            )}
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫星球 HanManXingQiu.com. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}